import microuniversoApi from "app/api/microuniversoApi"
import React, { useEffect, useState, useCallback, useMemo, useRef } from "react"
import { SenhaVendedor } from "./SenhaVendedor"
import { tratamentoErroPadrao } from "../../use-cases";

export type SenhaVendedorContainerProps = {
    onCancelar: () => void
    onAutenticado: () => void
    onAlterarSenha: () => void
}

export const SenhaVendedorContainer = (props: SenhaVendedorContainerProps) => {
    const [exibirBotaoAlteracaoSenha, setExibirBotaoAlteracaoSenha] = useState(false)
    const [urlLogo, setUrlLogo] = useState<string | null>(null)
    const [realizandoProcessamento, setRealizandoProcessamento] = useState<boolean>(false);
    const isMounted = useRef(true);

    useEffect(() => {
        sessionStorage.removeItem('orcamentoConcluido') // 467485 /458014
        return () => {
            isMounted.current = false; // para resolver erro: Can't perform a React state update on an unmounted component
        };
    }, []);

    const obterUrlLogo = useCallback(async () => {
        try {
            const logoUrl = await microuniversoApi.Usuario.obterUrlLogo();
            if (isMounted.current) {
                setUrlLogo(logoUrl);
            }
        } catch (error) {
            if (isMounted.current) {
                setUrlLogo(null);
            }
        }
    }, [])

    useEffect(() => {
        obterUrlLogo();
    }, [obterUrlLogo])

    const autenticar = useCallback(async (senha: string) => {
        try {
            setRealizandoProcessamento(true);
            const resposta = await microuniversoApi.Vendedor.autenticar(senha)

            if (!isMounted.current) return;

            if ("HasErrors" in resposta) {
                if (resposta.Error?.SubType === "AlterarSenhaVendedorException") {
                    setExibirBotaoAlteracaoSenha(true)
                }
            } else {
                if (resposta?.Autenticado) {
                    props.onAutenticado()
                }
            }
        } catch (e) {
            if (isMounted.current) {
                tratamentoErroPadrao(e)
            }
        } finally {
            if (isMounted.current) {
                setRealizandoProcessamento(false);
            }
        }
    }, [props.onAutenticado])

    const senhaVendedorProps = useMemo(() => ({
        onSenhaInformada: autenticar,
        onCancelar: props.onCancelar,
        exibirBotaoAlterarSenha: exibirBotaoAlteracaoSenha,
        onAlterarSenha: props.onAlterarSenha,
        urlLogo,
        realizandoProcessamento
    }), [autenticar, props.onCancelar, exibirBotaoAlteracaoSenha, props.onAlterarSenha, urlLogo, realizandoProcessamento])

    return <SenhaVendedor {...senhaVendedorProps} />
}